import React, { Fragment } from 'react';
import styles from '@/../sass/components/Validation.module.scss';

export default function ValidationErrors({ errors, custom }) {
    if (custom) {
        return (
            <Fragment>
            {errors && 
                <div className={styles.validationErrors}>
                    <i className={styles.icon + " fas fa-times-circle"}></i>
                    <div className={styles.errors}>
                        <span className={styles.error} key={index}>{errors} </span>
                    </div>
                </div>
            }
            </Fragment>
        );
    } else {
        return (
            Object.keys(errors).length > 0 && (
                <div className={styles.validationErrors}>
                    <i className={styles.icon + " fas fa-times-circle"}></i>
                    <div className={styles.errors}>
                        {Object.keys(errors).map(function (key, index) {
                            return <span className={styles.error} key={index}>{errors[key]} </span>;
                        })}
                    </div>
                </div>
            )
        );
    }
}
